var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "3d99b7894ee45df3dc7219051435f94e.png",
    width: 279,
    height: 267
});